import { myAccountHomepageSelectorStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

myAccountHomepageSelectorStyles.checkboxGroup = {
    ...myAccountHomepageSelectorStyles.checkboxGroup,
    css: css`
        align-items: flex-end;
        ${mediaQueriesBP.maxMD} {
            align-items: flex-start;
        }
    `,
};
